<template :style="'background-color:' + $themecolor + ';'">
    <v-row no-gutters class="head_bgActivity card cardbg">
      <div :style="'z-index: 0;font-size: 20px;font-weight: bold;position: relative;height:95px;color#fff;padding:15px;color:white;background-image: linear-gradient(0deg,' + $bgColor + '0%,' + $bgColor2 + '100%);'" fixed dense >
            <div :style="'height: 103px;background-color:' + $bgColor2 + ';width: 103px;border-radius: 100px;position: absolute;z-index: -1;right: 60px;top: -52px;'"></div>
            <div :style="'height: 89px;background-color:' + $bgColor3 + ';width: 89px;border-radius: 100px;position: absolute;z-index: -1;right: 0px;top: 2px;'"></div>
            <div :style="'height: 52px;background-color:' + $bgColor3 + ';width: 52px;border-radius: 100px;position: absolute;z-index: -1;right: 0px;top: 2px;'"></div>
            <a :style="'color:' + $textcolor">{{ $t("message.activity") }}</a>
            <!-- <div  class="fb-share-button" data-href="https://developers.facebook.com/docs/plugins/" data-layout="button_count" data-size="small">
              <a style="color: white;text-decoration: none;" target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&amp;src=sdkpreparse" class="fb-xfbml-parse-ignore">กิจกรรม</a>
            </div> -->
      </div>
      <!-- <v-col class="cardbg" :style="'background-color:' + $bgColor3 + ';'"> -->
        <div :style="'background-color:' + $bgColor3 + ';'">
          <v-fade-transition mode="out-in">
            <div style="min-height: 90vh" class="card1">
              <!-- <v-btn @click="share()">share</v-btn> -->
              <!-- <p class="result"></p> -->
              <event-steps v-if="$eventShopOption($route.query.shopId || GET_SHOPID(), 'stepActivities')"></event-steps>
              <activity-backup v-else></activity-backup>
              <!-- <all-activity></all-activity> -->
            </div>
          </v-fade-transition>
        </div>
      <!-- </v-col> -->
    </v-row>
</template>
<style scoped>
/* .card1 {
  height: 100%;
  overflow: hidden;
  background-color: --color_headline1 !important;
  border-radius: 0px 0px 0px 0px;
} */
.card {
  height: 100%;
  overflow: hidden;
}
.cardbg {
  background-repeat: no-repeat !important;
  background-size: 90% 110% !important;
  background-attachment: fixed;
  background-position: center;
}
</style>
<script>
import HeaderProfile from '../HeaderProfile'
import MenuItem from '../MenuItem'
import AllActivity from '../AllActivity'
import ActivityBackup from '../ActivityBackup'
import EventSteps from './EventSteps'
import { mapGetters } from 'vuex'

export default {
  name: 'ActivityMain',
  metaInfo: {
    // title: 'My Activity',
    meta: [
      { property: `og:title`, content: 'กิจกรรม' },
      { property: 'og:image', content: 'https://storage.googleapis.com/betask-linked/static/upload/Shop/SH261_20221229231505684117.jpeg' }
    ]
  },
  components: {
    'header-profile': HeaderProfile,
    'menu-item': MenuItem,
    'all-activity': AllActivity,
    'activity-backup': ActivityBackup,
    'event-steps': EventSteps
  },
  data () {
    return {
      activity: null,
      member: null,
      profile: [],
      shareData: {
        title: 'MDN',
        text: 'Learn web development on MDN!',
        url: `https://liff.line.me/1656906322-JN5MM8Ep/home?shopId=${this.shopId}`
      }
    }
  },
  async mounted () {
    if (this.$route.query.shopId) {
      if (typeof this.$session.getAll().shopId === 'undefined') {
        this.$session.remove('shopId')
        this.$session.start()
        this.$session.set('shopId', this.$route.query.shopId)
      }
    }
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    await this.transactionVisitPage()
    window.scrollTo(0, 0)
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),

    async getActivity () {
      const result = await this.callBeTaskAPI('get', `/activity/line/get`)
      if (Array.isArray(result)) {
        this.activity = result
      }
    },
    async share () {
      // const resultPara = document.querySelector('.result')
      let url = encodeURIComponent(`https://betask-loyalty-web.web.app/home?shopId=${this.shopId}&type=welcome`)
      // let redicrecUrl = encodeURIComponent(`https://betask-loyalty-web.web.app/home?shopId=${this.shopId}`)
      window.location = `https://www.facebook.com/v5.0/dialog/share?app_id=353978626320785&href=${url}`
      // try {
      //   await navigator.share(this.shareData).then((res) => { window.location.reload() })
      //   alert('test2')
      // } catch (err) {
      //   window.location.reload()
      //   resultPara.textContent = `Error: ${err}`
      // }
    },
    goBack () {
      window.history.back()
    },
    async transactionVisitPage () {
      const result = await this.callBeTaskAPI(
        'post',
        `/TransactionVisitPage/add`, {
          page: 'Activity',
          shopId: this.member.shopId,
          CREATE_USER: this.member.lineUserId
        }
      )
      if (result) {
      }
    }
  }
}
</script>
<style>
div.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Activity/Main.vue